import Insert from './Insert';
import Update from './Update';
import Remove from './Remove';
import Portfolio from './Portfolio';
import Upload from './Upload';
import Button from './Button';
import Print from './Print';
import Export from './Export';
import Publish from './Publish';
import Read from './Read';
import DefaultItem from './DefaultItem';

export default {
    Insert,
    Update,
    Remove,
    Portfolio,
    Upload,
    Button,
    Print,
    Export,
    Publish,
    Read,
    DefaultItem
}